var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("TABLE_HEADER_MODIFY_RECORD"),
            visible: "",
            width: "50%",
          },
          on: { close: _vm.onCancel },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { stripe: "", data: _vm.statusModifyTable },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "modifyUserName",
                  label: _vm.$t("SITE_TABLE_HEADER_MODIFIED_BY"),
                  width: "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateDate",
                  label: _vm.$t("SITE_TABLE_HEADER_MODIFIED_TIME"),
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm._f("formatDate")(scope.row.updateDate)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "currentStatusName",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                  label: _vm.$t("MODIFY_HEADER_AFTER"),
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v(_vm._s(_vm.$t("btn_close"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }